module.exports = __webpack_public_path__ + "static/media/acredited-provider-badge.54fc710e.svg";